import { render, staticRenderFns } from "./GroupRequestIcon.vue?vue&type=template&id=3f98d4b8&"
import script from "./GroupRequestIcon.vue?vue&type=script&lang=js&"
export * from "./GroupRequestIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports